import React from "react"
import { cn } from "../../styles/utils"
import { Form } from "../form"

type AuthFormProps = {
  children: React.ReactNode
  onSubmit: () => void
  className?: string
}

export const AuthForm: React.FC<AuthFormProps> = ({
  children,
  onSubmit,
  className,
}) => {
  return (
    <Form
      onSubmit={onSubmit}
      className={cn("w-full max-w-[400px] mx-auto", className)}
    >
      {children}
    </Form>
  )
}
